import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router';
import { authContext } from '../../context/AuthContext'

import Loading from "../helper/Loading"
import CenterButtonWithHeader from '../helper/CenterButtonWithHeader';
import scorm_api from '../../hooks/scormAPI';
import axios from 'axios';
// import moment from 'moment';
import getHyperlink from './LMSfuncs';

const { REACT_APP_GIBMP } = process.env;

// this just grabs the suspend data, plays it, and then exits. On exit it displays the return button
const ReviewQuiz = props => {
    const mounted = useRef(true)

    const user = useContext(authContext).user

    const history = useHistory()
    const params = useParams()

    const [hyperlink, setLink] = useState(history.location.state ? history.location.state.quizSrc : null)

    const [exited, setExited] = useState(false) // displays return button
    const [loading, setLoading] = useState(true)
    const [invalidID, setInvalidID] = useState(false) // if bad url, displays message

    // const [data, setData] = useState(null)

    async function initLoad() {
        getHyperlink(hyperlink, mounted, params.id, setInvalidID, setLink)

        scorm_api()

        // grab the most recently completed test record, and grab its suspend data
        const res = await axios.get('/api/test/all', {
            params: {
                student_id: user.username,
                courseId: params.id
            }

        })

        const mostRecent = res.data.tests.find(e => e.scormSuspendData !== null)

        if (mostRecent) window.API_1484_11.cmi.suspend_data = mostRecent.scormSuspendData
        console.log(res, mostRecent)

        // 

        // window.API_1484_11.apiLogLevel = 1; // Log everything (Debug)
        window.API_1484_11.apiLogLevel = 1;

        // mount update hooks 
        window.API_1484_11.on("Terminate", () => { setExited(true) });

        if (mounted.current) {

            // if there is not a valid quiz, then show an error
            if (mostRecent === undefined || mostRecent === null) setInvalidID(true)
            setLoading(false)

        }
    }



    useEffect(() => {

        initLoad()

        return () => {
            console.log("SCORM reset")
            window.API_1484_11.reset()

            mounted.current = false

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    const onReturn = () => {
        history.goBack()
    }

    const src = REACT_APP_GIBMP + hyperlink


    return (
        <>
            {invalidID === true ? <h1>Invalid course id</h1> :
                loading ? <Loading /> :
                    // takeQuiz?
                    exited ? <CenterButtonWithHeader title="Click below to return to the main course page" text="Return" onClick={onReturn} /> :
                        <iframe title="Review quiz window" src={src} width='1024' height='658'></iframe>

            }
        </>
    )


}

export default ReviewQuiz